import { Editor } from 'slate';
var insertDeserializedFragment = function insertDeserializedFragment(editor, _ref) {
  var fragment = _ref.fragment,
    plugins = _ref.plugins;
  Editor.withoutNormalizing(editor, function () {
    plugins.forEach(function (_ref2) {
      var deserialize = _ref2.deserialize;
      var getFragment = deserialize === null || deserialize === void 0 ? void 0 : deserialize(editor).getFragment;
      if (!getFragment) return;
      fragment = getFragment(fragment);
    });
    if (!fragment.length) return;
    plugins.some(function (_ref3) {
      var deserialize = _ref3.deserialize;
      var _deserialize$preInser, _deserialize;
      return (deserialize === null || deserialize === void 0 ? void 0 : (_deserialize$preInser = (_deserialize = deserialize(editor)).preInsert) === null || _deserialize$preInser === void 0 ? void 0 : _deserialize$preInser.call(_deserialize, fragment)) === true;
    });
    editor.insertFragment(fragment);
  });
};
var isDeserializerEnabled = function isDeserializerEnabled(editor, plugins, deserializerId) {
  return plugins.every(function (_ref4) {
    var deserialize = _ref4.deserialize;
    var _deserialize$isDisabl, _deserialize;
    return !(deserialize !== null && deserialize !== void 0 && (_deserialize$isDisabl = (_deserialize = deserialize(editor)).isDisabled) !== null && _deserialize$isDisabl !== void 0 && _deserialize$isDisabl.call(_deserialize, deserializerId));
  });
};
export { insertDeserializedFragment, isDeserializerEnabled };